import { useContext } from "react";
import { MerchantAccountSettingsContext } from "./MerchantAccountSettingsProvider";

export default function useMerchantAccountSettingsContext() {
  return useContext(MerchantAccountSettingsContext);
};
